<script setup>
import { ref } from "vue";
import Blocks from "@/components/pushmd/Blocks.vue";
import { homeBlocks } from "@/brochureContent";

// Use the imported blocks content, wrapped in ref to make it reactive
const blocks = ref(homeBlocks);
</script>

<template>
  <div class="min-h-screen bg-background">
    <main>
      <!-- Use the Blocks component to render all defined blocks -->
      <Blocks :blocks="blocks" />
    </main>
  </div>
</template>